/**
 * Market Pulse quotes gold & fiat in toman; the world gold ounce (`ons`) is the exception. It is
 * quoted in US dollars (`price_usd`, `quote_currency: "USD"`) with the toman value beside it, so
 * the site shows it like a crypto coin: the dollar price first, the toman price under it.
 */
export interface UsdQuoteFields {
    price_usd?: number | string | null;
    quote_currency?: string | null;
}

export const isUsdQuoted = (item?: UsdQuoteFields | null): boolean =>
    (item?.quote_currency || '').toUpperCase() === 'USD' && Number(item?.price_usd) > 0;

export const usdPriceOf = (item?: UsdQuoteFields | null): number =>
    isUsdQuoted(item) ? Number(item?.price_usd) : 0;
